import { Nullable } from "src/utils/util.types";
import { FaBuilding as Building } from "react-icons/fa";
import { useGetOrganizationByIdQuery } from "src/features/organizations/organization.service";
import { Link } from "react-router-dom";

type OrganizationInfoProps = {
  organizationId: Nullable<string>;
};

export const OrganizationInfo = ({ organizationId }: OrganizationInfoProps) => {
  const { data: organization } = useGetOrganizationByIdQuery("bHWa1ujC56bt9Nk3Jpb9", {
    skip: !organizationId,
  });

  return (
    <>
      {organization && (
        <div className="border-t pt-3">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Organization</h3>
          <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl shadow-lg border border-blue-200 p-6 transition-all duration-200 hover:shadow-xl hover:border-blue-400">
            <div className="flex items-center space-x-4">
              {organization.logo ? (
                <img
                  src={organization.logo}
                  alt={`${organization.name} Logo`}
                  className="w-14 h-14 rounded-full object-contain bg-white p-1 border border-gray-200" // Larger, rounded, object-contain for logos, with border and padding
                />
              ) : (
                <svg
                  className="w-14 h-14 text-indigo-500 bg-indigo-100 rounded-full p-3 flex-shrink-0"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2H6a2 2 0 01-2-2V4zm2 0v12h8V4H6zm2 3a1 1 0 000 2h4a1 1 0 100-2H8zm0 3a1 1 0 000 2h4a1 1 0 100-2H8zm0 3a1 1 0 000 2h4a1 1 0 100-2H8z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              )}
              <div className="flex-1 min-w-0">
                <Link
                  to={`/organizations/${organization.id}`}
                  className="text-blue-700 hover:text-blue-900 font-bold text-xl truncate block no-underline" // Larger, bolder name, truncate for long names
                >
                  {organization.name}
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
